import makeStyles from '@mui/styles/makeStyles';
import {deepOrange} from "@mui/material/colors";

const useStyles = makeStyles((theme) => ({
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    profileInfo: {
        display: 'flex',
        alignItems: 'center',
    },
    providerInfoText: {
        marginRight: 10,
        fontSize: 14,
        marginTop: 2,
        marginBottom: 2,
        textAlign: 'right'
    },
    userInfoText: {
        marginRight: 10,
        fontSize: 14,
        marginTop: 2,
        marginBottom: 2,
        textAlign: 'right',
        fontWeight: 600
    },
    card: {
        maxWidth: 500,
        minWidth: 300,
        border: "none",
        boxShadow: "none",
        backgroundColor: 'transparent'
    },
    editIcon: {
        color: theme.palette.primary.main,
        height: 30,
        width: 30
    },
    logoutIcon: {
        color: theme.palette.primary.secondary,
        height: 30,
        width: 30
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginLeft: 5,
        marginRight: 5
    }
}));

export {useStyles};
